import { useSelector } from "react-redux";
import jwtDecode from "jwt-decode";

const useDecodedToken = () => {
  const { user } = useSelector((state) => state.auth);

  if (!user?.access_token) return null;

  try {
    return jwtDecode(user.access_token);
  } catch {
    return null; // token invalid hoga to crash nahi hoga
  }
};

const useUserType = () => {
  const token = useDecodedToken();
  return token?.user_type ?? null;
};
const UserType = () => {
  const token = useDecodedToken();
  return token?.user_type ?? null;
};

const useUserId = () => {
  const token = useDecodedToken();
  return token?.webuser_id ?? null;
};

const UserTypeEnum = { FACULTY: "FACULTY", ADMIN: "ADMIN" };

export { useUserType, useUserId, UserType, UserTypeEnum };